const translations = {
  "en": {
    "Give me a clear overview of %{var0}. Should I invest in it?": "Give me a clear overview of %{var0}. Should I invest in it?",
    "streamLoading": "streamLoading"
  },
  "zh-tw": {
    "Give me a clear overview of %{var0}. Should I invest in it?": "幫我清楚分析一下 %{var0}，它值得投資嗎？",
    "streamLoading": "載入中..."
  }
};

export default translations;
